/* eslint-disable max-len */
import React from "react";
import get from "lodash/get";
import cx from "classnames";

import { Avatar } from "../../../../../components/Avatar/Avatar";
import { LinkButton } from "../../../../../components/Buttons/LinkButton";
import { titles, errorMsgs, STATUS_NOT_ELIGIBLE, UPLOAD } from "./constants";

import {
  StyledSearchedAppInfoDocumentsWrapper,
  StyledDocumentsContentWrapper,
  StyledDocumentsErrorWrapper,
  StyledDocumentTitle
} from "./styled";
import { concatNameFromSignatory } from "../../../../../utils/concatName";

export const Documents = ({ signatoryInfo, downloadDocument, docs }) => {
  const headingClassName = cx("checkListData", "heading");
  //ro-assist-brd3-1
  const listDocuments = (docs, downloadDocument, docType) => {
    const docList = get(docs, docType, []) ? get(docs, docType, []) : [];
    return docList.map((application, index) => (
      <div className={"applicationRow"} key={index}>
        <div className={"checkListData"}>
          {STATUS_NOT_ELIGIBLE.includes(application.uploadStatus)
            ? application.documentTitle
            : application.documentTitle && application.documentTitle !== ""
            ? application.documentTitle.replace(UPLOAD, "") + " "
            : ""}

          <br />
          {application.fileName}
        </div>
        <div className={"checkListData"}>Uploaded</div>
        {!STATUS_NOT_ELIGIBLE.includes(application.uploadStatus) && (
          <div className={"checkListData"}>
            <LinkButton
              index={index}
              title={titles.PRINT_DOWNLOAD_TITLE}
              onClick={() => downloadDocument(application.fileName, application.fileName)}
            />
          </div>
        )}
      </div>
    ));
  };
  return (
    <>
      <StyledDocumentTitle>{titles.COMPANY_TITLE}</StyledDocumentTitle>
      {get(docs || {}, "companyDocuments", [])?.length ? (
        <StyledSearchedAppInfoDocumentsWrapper>
          <div className={"applicationRow"}>
            <div className={headingClassName}>{titles.DOCUMENT_TITLE}</div>
            <div className={headingClassName}>{titles.UPLOAD_STATUS_TITLE}</div>
            <div className={headingClassName}>{titles.ACTIONS_TITLE}</div>
          </div>
          {listDocuments(docs, downloadDocument, "companyDocuments")}
          {listDocuments(docs, downloadDocument, "companyBankStatements.documents")}
          {listDocuments(docs, downloadDocument, "companyInvoices.documents")}
          {listDocuments(docs, downloadDocument, "companyAddressProof.documents")}
        </StyledSearchedAppInfoDocumentsWrapper>
      ) : (
        <StyledDocumentsErrorWrapper>
          {errorMsgs.COMPANY_DOCUMENT_ERROR}
        </StyledDocumentsErrorWrapper>
      )}
      <br />
      <StyledDocumentTitle>{titles.STAKEHOLDER_TITLE}</StyledDocumentTitle>
      {Object.keys(docs.stakeholdersDocuments || {}).length ? (
        (signatoryInfo || []).length &&
        signatoryInfo.map((user, index) => {
          const { editedFullName, fullName, signatoryId } = user;
          const signatoryFullName = editedFullName || fullName || concatNameFromSignatory(user);

          return (
            <div key={index} style={{ width: "100%" }}>
              <StyledDocumentsContentWrapper>
                <Avatar fullName={signatoryFullName} index={index} />
                <div className={"userInfo"}>
                  <div className={"nameField"}>{signatoryFullName}</div>
                </div>
              </StyledDocumentsContentWrapper>
              <StyledSearchedAppInfoDocumentsWrapper>
                <div className={"applicationRow"}>
                  <div className={headingClassName}>{titles.DOCUMENT_TITLE}</div>
                  <div className={headingClassName}>{titles.UPLOAD_STATUS_TITLE}</div>
                  <div className={headingClassName}>{titles.ACTIONS_TITLE}</div>
                </div>
                {listDocuments(
                  docs,
                  downloadDocument,
                  `stakeholdersDocuments['${index}_${signatoryId}'].documents`
                )}
                {listDocuments(
                  docs,
                  downloadDocument,
                  `stakeholdersDocuments['${index}_${fullName}'].documents`
                )}
                {listDocuments(
                  docs,
                  downloadDocument,
                  `stakeholdersDocuments['${index}_${user.fullName}'].personalBankStatements.documents`
                )}
                {listDocuments(
                  docs,
                  downloadDocument,
                  `stakeholdersDocuments['${index}_${user.fullName}'].personalBackground.documents`
                )}
                {listDocuments(
                  docs,
                  downloadDocument,
                  `stakeholdersDocuments['${index}_${user.fullName}'].additionalDocuments`
                )}
              </StyledSearchedAppInfoDocumentsWrapper>
            </div>
          );
        })
      ) : (
        <StyledDocumentsErrorWrapper>
          {errorMsgs.STAKEHOLDERS_DOCUMENT_ERROR}
        </StyledDocumentsErrorWrapper>
      )}
    </>
  );
};
